const languageConfig = {
  // Used to load video streams in the correct language
  iso639Conversions: {
    // ISO 639-1: ISO 639-2
    da: 'dan',
    de: 'deu',
    en: 'eng',
    es: 'spa',
    fj: 'fij',
    fr: 'fra',
    hu: 'hun',
    id: 'ind',
    it: 'ita',
    ja: 'jpn',
    km: 'khm',
    ko: 'kor',
    mn: 'mon',
    nl: 'nld',
    no: 'nor',
    pl: 'pol',
    pt: 'por',
    ru: 'rus',
    sm: 'smo',
    th: 'tha',
    tl: 'tgl',
    to: 'ton',
    vi: 'vie',
    zh: 'zho',
    'zh-HK': 'yue',
  },
  // Configured on the server to download the correct language pack.
  additionalLangs: ['ar', 'fj', 'hu', 'id', 'km', 'mn', 'nl', 'no', 'pl', 'sm', 'th', 'tl', 'to', 'vi', 'zh-hans'],
  chineseLocales: ['zh-CN', 'zh-HK', 'zh-TW'],
  chineseLangMapping: {
    'zh-CN': 'zh-hans',
    'zh-HK': 'zh',
    'zh-TW': 'zh',
  },
  complexSiteLanguages: ['en', 'es', 'fr', 'pt'],
  languageTranslations: {
    pon: 'Mahsen en Pohnpei',
    tl: 'Tagalog',
    fj: 'Viti',
  },
}

export default languageConfig
